/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { SocketService } from '../services/socket.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html'
})
export class LogoutComponent implements OnInit {

  constructor(private router: Router,
              private authService: AuthService,
              private socketService: SocketService) { }

  ngOnInit() {
    this.authService.logout().subscribe(
      (result: any) => {
        this.router.navigate(['login']);
        // since the socket will persist, we need
        // to implicitly disconnect
        this.socketService.disconnect();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/logout/logout.component.ts